const basePath = '/pyxis-service/v1';
export const loginApis = {
    fetchCaptcha: `${basePath}/captcha/sms`,
    loginPysix: `${basePath}/login`,
    logoutPysix: `${basePath}/logout`,
    getUserInfo: `${basePath}/user-info`,
};

export const announcementApis = {
    agreeAnnouncement: `${basePath}/user/agree-announcement`,
};

export const configApis = {
    learnLinkConfig: `${basePath}/learn-link-config`,
    visitedLinkConfig: `${basePath}/visited-link-config`,
    fetchSaml: `${basePath}/saml`,
    fetchPageUrl:`${basePath}/oauth2/login`,
};

export const htmlApis = {
    userAgreement: '/html/user-agreement.html',
    privacyStrategy: '/html/privacy-strategy.html',
};
